<template>
  <SplitContainer
    class="pb-24"
    color="#FFF6E9"
  >
    <template #head>
      <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
        <div class="flex flex-col py-2.5">
          <div class="heading text-blue pb-5 font-bold">
            {{ currentPage.title }}
          </div>
        </div>
      </div>
    </template>

    <template #split>
      <div class="grid-base grid-cols-1 xl:grid-cols-1">
        <img
          v-if="currentPage.active_image"
          class="image aspect-long my-2.5 lg:my-10 lg:h-96"
          :src="currentPage.active_image.url"
          :alt="currentPage.title"
        >
      </div>
    </template>

    <template #default>
      <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
        <div />
        <SofieText
          class="prose prose-headings:text-blue max-w-full font-medium"
          :value="currentPage.template.standard_text"
        />
      </div>
    </template>
  </SplitContainer>
</template>

<script setup lang="ts">
definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const currentPage = useSofiePage();
</script>
